export default {
  namespaced: true,

  state: {
    data: {
      default_city: {
        2300000600000: 'Новороссийск',
        2303300001000: 'поселок Волна',
      },
      default_stevedore: {
        2300000600000: [
          { name: 'НЗТ', id: 1 },
          { name: 'НКХП', id: 2, traders: [] },
          { name: 'КСК', id: 3, traders: [] },
        ],
        2303300001000: [{ name: 'ЗТК Тамань', id: 13, traders: [] }],
      },
      default_consignee: [
        { name: "ООО 'МИРОГРУПП РЕСУРСЫ'", id: 3, stevedore: [1, 2] },
        { name: "ООО 'ОЗК-ЮГ'", id: 4, stevedore: [2] },
      ],
    },
  },
  getters: {
    getDefault: state => state.data,
  },
}
